import styled from 'styled-components/macro';
import { colorCoreWhite1000 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { RegularTextLevel3 } from '@yme/tokens/typography';
export const DescriptionStyled = styled(FlexWrapper) `
  padding: 24px 16px;
  word-wrap: break-word;
  background: ${({ blockStrategy }) => blockStrategy && blockStrategy};
`;
export const ShowMoreWrapperStyled = styled(RegularTextLevel3) `
  color: ${colorCoreWhite1000};
`;
